import actions from '../../actionTypes';

export default trigger => {
  return {
    type: actions.EDIT_TRIGGER,
    trigger
  };
};



// WEBPACK FOOTER //
// ./src/reducers/triggers/actions/editTrigger.js